import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

let testing = false

function normalise_phone_number(phone_number: string): string {
	return phone_number.replace(/[^0-9]/g, '')
}

@Injectable({
	providedIn: 'root'
})
export class OTPService {

	private url = 'https://rentastore.co.za/backend/otp/'

	constructor(private http: HttpClient) { }

	verify(cellphone: string, pin: string): Promise<boolean> {

		return new Promise((resolve, reject) => {

			if (testing) {
				resolve(true)
			} else {
				this.http
				.post<any>(
					this.url,
					'cellphone='+normalise_phone_number(cellphone)+'&pin='+escape(pin),
					 {
						headers: new HttpHeaders ({
							'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
						}),
					}
				)
				.toPromise()
				.then(response => resolve(true), reason => reject(reason))
			}
		})
	}

	generate(cellphone: string, token: string): Promise<boolean> {

		return new Promise((resolve, reject) => {

			if (testing) {
				resolve(true)
			} else {
				this.http
				.post<any>(
					this.url,
					'cellphone='+normalise_phone_number(cellphone)+'&token='+escape(token),
					{
						headers: new HttpHeaders ({
							'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
						}),
					}
				)
				.toPromise()
				.then(response => resolve(true), reason => reject(reason))
			}
		})
	}
}
